export function supportsViewTransition() {
  return typeof document !== 'undefined' && typeof document.startViewTransition === 'function'
}

export function prefersReducedMotion() {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export function withRouteViewTransition(runNavigation) {
  if (!supportsViewTransition() || prefersReducedMotion()) {
    return runNavigation()
  }

  return document.startViewTransition(() => Promise.resolve(runNavigation()))
}
